export default __webpack_public_path__ + "static/media/warehousing.2ba8d29e.jpg";